import React, { Component } from 'react';
import { Example, Properties, SourceCode, Tip } from 'examples';
import ApplicationHeader from '../ApplicationHeader/ApplicationHeader';
import ApplicationHeaderTabs from './ApplicationHeaderTabs';
import Button from '../Button/Button';
import Checkbox from '../Checkbox/Checkbox';
import Group from '../Group/Group';

class ApplicationHeaderTabsExample extends Component {

  state = {
    hideFakeLinks: false,
    selected: 0, // fake selection. normally the selection should not be set
  };

  onHideFakeLinks = () => this.setState({ hideFakeLinks: !this.state.hideFakeLinks });

  onChangeProps = e => this.setState(e.target.value);

  onAdd = () => window.showAppInfo('add');

  onDownload = () => {
    window.showAppInfo('download');
    this.setState({ inProgress: true });
    setTimeout(() => {
      this.setState({ inProgress: false });
    }, 5000);
  };

  onSelection = e => {
    const selected = parseInt(e.target.getAttribute('data-index'), 10);

    e.preventDefault();
    window.showAppInfo(e.target.innerText);
    this.setState({ selected });
  };

  render() {
    const { hideFakeLinks, ...rest } = this.state;

    return (
      <Example {...this.props}>
        <Properties defaultProps={ApplicationHeaderTabs.defaultProps} propTypes={ApplicationHeaderTabs.propTypes} propValues={this.state} onChange={this.onChangeProps}>
          <Tip>Try clicking on the Download button in the header.</Tip>
        </Properties>
        <ApplicationHeader title="ApplicationHeader"/>
        <ApplicationHeaderTabs {...rest}>
          {!hideFakeLinks && <a href="/general" data-index="0" onClick={this.onSelection}>General</a>}
          {!hideFakeLinks && <a href="/history" data-index="1" onClick={this.onSelection}>History</a>}
          {!hideFakeLinks && <a href="/log" data-index="2" onClick={this.onSelection}>Log</a>}
          <Button iconName="download" inProgress={this.state.inProgress} onClick={this.onDownload} disabled={this.state.inProgress}/>,
          <Button iconName="add" onClick={this.onAdd}/>,
        </ApplicationHeaderTabs>
        <Group>
          <p>
            This is a mockup example that will not navigate
            as <a href="https://github.com/ReactTraining/react-router"><code>react-router</code></a> and
            its <a href="https://github.com/ReactTraining/react-router/blob/master/packages/react-router-dom/docs/api/Link.md"><code>Link</code></a> component
            is not included in this library. This example uses a standard <code>a href</code> element and
            the <em>selected</em> prop to simulate a typical usage.
          </p>
          <Checkbox checked={hideFakeLinks} onChange={this.onHideFakeLinks} label="Hide links"/>
        </Group>
        <SourceCode title="Example code" expanded={true}>
          {
            '<ApplicationHeaderTabs>\n' +
            '  <Link to="myapp/general">General</Link>\n' +
            '  <Link to="myapp/history">History</Link>\n' +
            '  <Link to="myapp/log">Log</Link>\n' +
            '</ApplicationHeaderTabs>'
          }
        </SourceCode>
        <SourceCode querySelector=".application-header-tabs-example .core-application-header-tabs"/>
      </Example>
    );
  }

}

ApplicationHeaderTabsExample.tags = 'navigation';

export default ApplicationHeaderTabsExample;

